/**
 * Feature中介房源展示(Carousel)
 * 
 * @Author: Focci
 * @Date: 2024-10-11 16:39:51
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-11 16:39:51
 */

'use client'

import useFetch from '@hook/useFetch'
import useLazyComponent from '@hook/useLazyComponent'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'
import { Waypoint } from 'react-waypoint'
import { isArray } from 'lodash-es'
import PropertyItemScoff from '../PropertyItemScoff'

export default function SimilarProperties({ uid }) {
  const th = useTranslations('house')
  const [enter, setEnter] = useState(false)

  const { Wedget: SimilarPropertiesCard, getWedget, ready } = useLazyComponent()
  const { data, isLoading } = useFetch(enter ? 'similar/properties' : null, { limit: 6, uid })
  
  const handleEnter = useCallback(() => {
    getWedget(() => import('./SimilarPropertiesCard'))
    setEnter(true)
  }, [getWedget])

  if(isArray(data) && data.length === 0) {
    return null
  }

  return (
    <Waypoint onEnter={handleEnter}>
      <PropertyItemScoff
        title={th('similarProperties')}
        moduleName={th('similarProperties')}
        id="similar-properties"
        border={false}
        titleClassName="flex-col md:flex-row !items-start"
      >
        {
          (!ready || isLoading)
            ? <div className="h-[21rem] bg-cf8" />
            : <SimilarPropertiesCard data={data} />
        }
      </PropertyItemScoff>
    </Waypoint>
  )
}
